<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <d-form-row>
          <d-col>
            <c-input container-class="mb-3" label="Nom de la devise" placeholder="Ex: XAF" v-model="name"
                     :state="nameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Slug" placeholder="Ex: FCFA" v-model="slug" :state="slugState">
              Veuillez saisir un slug
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3"
                     label="Valeur en XAF" placeholder="Ex: 500"
                     v-model="xaf_value" :state="xaf_valueState">
              Veuillez saisir un montant positif
            </c-input>
            <c-input type="textarea" container-class="mb-3" label="Description" placeholder="Entrez une description..."
                     v-model="description"/>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalVisible = true">
            <i class="fa fa-plus mr-1"></i> Ajouter une devise
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="data" :fields="fields" :actions="actions" :per-page="10">
          <p class="text-center" slot="empty">Aucune devise trouvée.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, Regex, Toast} from "@/helpers"

export default {
  title: "Paramètres des devises",
  data() {
    return {
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'name', label: 'Nom de la devise', sortable: true},
        {key: 'slug', label: 'Slug', sortable: true},
        {key: 'xaf_value', label: 'Valeur en XAF', sortable: true},
        {key: 'description', label: 'Description'},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-edit', title: "Modifier la devise", handler: this.onItemSelect},
        {type: 'outline-danger', icon: 'fa fa-times', title: "Supprimer la devise", handler: this.onItemRemove},
      ],

      modalVisible: false,

      selectedItem: null,

      name: '',
      slug: '',
      xaf_value: '',
      description: '',

      submitted: false,
      fetchingFormSubmit: false,
    }
  },
  computed: {
    itemSelected() {
      return !!this.selectedItem
    },
    modalTitle() {
      return this.itemSelected ? "Edition d'une devise" : "Ajout d'une devise"
    },
    nameState() {
      return !this.submitted || this.name.trim().length > 0
    },
    slugState() {
      return !this.submitted || this.slug.trim().length > 0
    },
    xaf_valueState() {
      return !this.submitted || Regex.isStrictPositiveNumber(this.xaf_value)
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/currency/list')
      .then(res => this.data = res.data.currencies.map(this.mapItem))
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return item
    },
    onItemSelect(item) {
      this.selectedItem = item
      this.name = item.name
      this.slug = item.slug
      this.xaf_value = item.xaf_value
      this.description = item.description
      this.modalVisible = true
    },
    clearFields() {
      this.name = ''
      this.slug = ''
      this.xaf_value = ''
      this.description = ''
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.selectedItem = null
      this.error = null
      this.clearFields()
    },
    isFormValid() {
      return this.nameState && this.slugState && this.xaf_valueState
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      const route = this.itemSelected ? '/currency/update' : '/currency/create'
      const extraData = this.itemSelected ? {currency_id: this.selectedItem.id} : {}

      this.fetchingFormSubmit = true
      Api.postFormData(route, {
        name: this.name,
        slug: this.slug,
        xaf_value: this.xaf_value,
        description: this.description,
        ...extraData
      })
        .then(res => {
          const currency = this.mapItem(res.data.currency)
          const operation = this.itemSelected ? "mise à jour" : "créée"

          if (this.itemSelected)
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, currency)
          else
            this.data.push(currency)

          this.onModalClose()

          Toast.success(`La devise "${currency.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onItemRemove(item) {
      const ans = prompt(`Veuillez saisir SUPPRIMER pour supprimer la devise "${item.name}".`)
      if (ans !== 'SUPPRIMER') return

      Toast.loading("Suppression de la devise...")
      Api.postFormData('/currency/delete', {
        currency_id: item.id
      })
        .then(res => {
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`La devise "${item.name}" a été supprimée avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    }
  }
}
</script>

<style scoped>

</style>
